<template>

  <ol class="breadcrumb" v-if="items.length" ref="breadcrumb">
    <li
      v-for="item in innerItems"
      class="breadcrumb-item"
      v-bind:class="{active: item.active}">
      <router-link
        v-if="!item.active && item.name !== 'Back'"
        :to="{name: item.name, params: item.params, hash: item.hash ? item.hash: undefined}">
        {{ t(item.label) }}
      </router-link>
      <a v-if="item.name === 'Back'" @click="_back($event)" href="">{{ t(item.label) }}</a>
      <span
        v-if="item.active">
        {{ t(item.label) }}
      </span>
    </li>
    <li class="breadcrumb-item breadcrumb-item__show-more" ref="showMore" @click="_showAll">
      <span v-if="" class="show-more">
        ...
      </span>
    </li>
  </ol>

</template>

<script>
export default {
  name:  'Breadcrumb',
  props: {
    items: {
      type:    Array,
      default: () => {
        return []
      }
    }
  },

  data(){
    return {
      breadcrumbWidthBreakpoint: Number.MAX_SAFE_INTEGER
    }
  },

  computed: {
    innerItems: function () {

      for (let i = 0; i < this.items.length; i++) {
        let item = this.items[i]

        if (!item.hasOwnProperty('name')) {
          continue
        }

        if (!item.hasOwnProperty('params')) {
          item.params = {}
        }

        if (!item.hasOwnProperty('label')) {
          item.label = 'label not defined!'
        }

        if (!item.hasOwnProperty('active')) {
          item.active = false
        }

        return this.items
      }
    }
  },

  created () {
    window.addEventListener('resize', this._resize)
  },

  updated () {
    this._resize()
  },

  destroyed () {
    window.removeEventListener('resize', this._resize)
  },

  methods: {
    _back (event) {
      event.preventDefault()

      this.$router.go(-1)
    },

    _resize () {
      let breadcrumbHeight = this.$refs.breadcrumb.clientHeight
      let breadcrumbWidth = this.$refs.breadcrumb.clientWidth

      if (breadcrumbHeight > 22) {
        this._hide()
        this.breadcrumbWidthBreakpoint = breadcrumbWidth
      }

      if(this.breadcrumbWidthBreakpoint < breadcrumbWidth) {
        this._showAll()
        this.breadcrumbWidthBreakpoint = Number.MAX_SAFE_INTEGER
      }
    },

    _hide(){
      this.$refs.breadcrumb.style.height       = '22px'
      this.$refs.breadcrumb.style.overflow     = 'hidden'
      this.$refs.breadcrumb.style.paddingRight = '20px'
      this.$refs.showMore.style.display        = 'inline'
    },

   _showAll(){
     this.$refs.breadcrumb.style.height       = 'auto'
     this.$refs.breadcrumb.style.overflow     = 'hidden'
     this.$refs.breadcrumb.style.paddingRight = '0'
     this.$refs.showMore.style.display        = 'none'
   }
  }

}
</script>

<style scoped>
.page-header .breadcrumb {
  position: relative;
}

.breadcrumb .breadcrumb-item__show-more {
  position: absolute;
  top: 0;
  right: 0;
  display: none;
}

.breadcrumb .breadcrumb-item__show-more::before {
  content: '';
}
</style>
